import _map from 'lodash/map';
import _cloneDeep from 'lodash/cloneDeep';
import { v4 as uuidv4 } from 'uuid';

import initialState from './initialState';
import actionType from './actionTypes';

const sourceConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_ALL_REF_DATA_SOURCE_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                refDataSourceConfigurations: action.payload,
                gridRefDataSourceConfigurations: _cloneDeep({
                    fielddata: initialState.gridRefDataSourceConfigurations.fielddata,
                    instances: _map(action.payload, (config) => ({
                        ...config,
                        id: uuidv4(),
                        filing_date: null,
                        // created_date : moment(config.created_date, "YYYY MM DD")
                    })),
                }),
                refDataSourceConfigs: _map(action.payload, (item) => ({
                    label: item.source_name,
                    value: item.ref_id,
                    ...item,
                })),
            };
        }
        case actionType.UPDATE_SOURCE_NAMES:
            return {
                ...state,
                selectedSourceConfigs: action.payload,
            };
        case actionType.GET_REF_DATA_SOURCE_MAPPING:
            const { sourceFieldsSettings, unMappedDataDictionaries, mappedDataDictionaries } = action.payload;
            return {
                ...state,
                sourceFieldsSettings,
                unMappedDataDictionaries,
                mappedDataDictionaries,
            };
        case actionType.GET_REF_SOURCE_SELECTION_BOX:
            return {
                ...state,
                mappedDDForSelectionBox: action.payload,
            };
        case actionType.GET_ALL_SOURCE_IMPORT_COMMENTS:
            return {
                ...state,
                sourceImportComments: action.payload,
            };
        case actionType.GET_ALL_SOURCE_SETTINGS:
            return {
                ...state,
                refDataSourceSettings: action.payload,
            };
        default:
            return state;
    }
};

export default sourceConfigurationReducer;
